import { useDispatch, useSelector } from 'react-redux';
import { kpiBucketActions } from '../reducers/kpi-dashboard.reducer';
import { KpiDashboardState, RootState } from '../types/store.types';

export const useKpiDashboardStore = () => {
  const kpiDashboardSelector = useSelector<RootState, KpiDashboardState>((state) => state.kpiBucket);
  const dispatch = useDispatch();

  const {
    setSelectedBranch,
    setSelectedType,
    addBranchList,
    setAnnouncementData,
    setToDate,
    setFromDate,
    setDropdownLoader,
    setKpiBranch,
  } = kpiBucketActions;

  return {
    dispatch,
    kpiDashboardSelector,
    addBranchList,
    setAnnouncementData,
    setFromDate,
    setToDate,
    setSelectedBranch,
    setSelectedType,
    setDropdownLoader,
    setKpiBranch,
  };
};
